<template>
    <div id="residence-assistant-manager">
        <v-overlay absolute="" opacity="0.2" :value="loader">
            <v-progress-circular :color="appColor" indeterminate size="32"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar.status" top :color="snackbar.color" :timeout="snackbar.timeout">
            <v-icon class="mr-1">{{ snackbar.icon }}</v-icon> {{ snackbar.message }}
        </v-snackbar>
        <residence-assistant-manager-toolbar></residence-assistant-manager-toolbar>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <residence-assistant-management :buildings="buildings" :data="data" @refreshData="refreshData"
                        @setNotification="setNotification">
                    </residence-assistant-management>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import ResidenceAssistantManagement from '../../components/Admin/ResidenceAssistantManager/Manager'
import ResidenceAssistantManagerToolbar from '../../components/Admin/ResidenceAssistantManager/Toolbar';

export default {
    name: 'residence-assistant-manager',
    components: {
        ResidenceAssistantManagement,
        ResidenceAssistantManagerToolbar
    },
    data() {
        return {
            buildings: [],
            data: [],
            loader: true,
            refreshTimer: '',
            snackbar: {
                color: 'success',
                icon: '',
                message: '',
                status: false,
                timeout: 5000
            }
        }
    },
    methods: {
        getResidenceAssistantData() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getRA`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to view this resource. Please refresh your application.`, true);
                    } else if (!json.result.match(/OK/i)) {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `Residence Assistant data could not be retrieved. Please contact your system administrator.`, true);
                    }

                    that.buildings = json.buildings;
                    that.data = json.data;
                    that.setLoader(false);
                })
                .catch(function () {
                    that.setLoader(false);
                })
        },
        refreshData() {
            this.getResidenceAssistantData();
        },
        setLoader(bool) {
            this.loader = bool;
        },
        setNotification(color, icon, message, status) {
            // Reset snackbar
            this.snackbar.status = false;

            // Set snackbar fields
            this.snackbar.color = color;
            this.snackbar.icon = icon;
            this.snackbar.message = message;
            this.snackbar.status = status;
        }
    },
    computed: {
        appColor() {
            return '#191b2a';
        }
    },
    created() {
        this.refreshData();
        this.refreshTimer = setInterval(this.refreshData, 60000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.refreshTimer);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.refreshTimer);
    }
}
</script>